import { Checkbox } from "primereact/checkbox"
import { InputNumber } from "primereact/inputnumber"
import { useAppSelector } from "../../../../../../stateManagement/hooks/redux"
import { useDispatch } from "react-redux"
import { setCustomMapAppliedFilters, setCustomMapFiltersState } from "../../../../../../stateManagement/reducers/custom/CustomMapSlice"
import { setItemWebStorage } from "../../../../../../features/webStorageSaver"
import { delay } from "../../../../../../features/dataFunctions/dataFunctions"

export default function CustomFilterInput({ fieldName, objectTypeName }: any) {
    const dispatch = useDispatch()
    const filtersState = useAppSelector(state => state.customMap.customMapFiltersState)
    const appliedFilters = useAppSelector(state => state.customMap.customMapAppliedFilters)
    const { valueType, value, ignoreFilterValue } = filtersState[fieldName]

    // изменение состояния фильтров
    function setInputFilterValue(fieldName: any, value: any) {
        // новое состояние фильтров
        let newFiltersState = structuredClone(filtersState)
        newFiltersState[fieldName].value = value
        newFiltersState[fieldName].ignoreFilterValue.checked = false
        dispatch(setCustomMapFiltersState(newFiltersState))
        setItemWebStorage(`customMapFiltersState-${objectTypeName}`, newFiltersState)
        // новые примененные фильтры
        let newAppliedFilters = {
            ...appliedFilters,
            [fieldName]: {
                ...appliedFilters[fieldName],
                [`ignore-${fieldName}`]: false,
                value
            }
        }
        delay(() => {
            dispatch(setCustomMapAppliedFilters(newAppliedFilters))
            setItemWebStorage(`customMapAppliedFilters-${objectTypeName}`, newAppliedFilters)
        }, 1000)
    }

    function applyFilterInputIgnoreValue(checked: boolean, fieldName: string) {
        let newFiltersState = structuredClone(filtersState)
        let appliedFilter
        newFiltersState[fieldName].ignoreFilterValue.checked = checked
        appliedFilter = { [`ignore-${fieldName}`]: checked }
        dispatch(setCustomMapFiltersState(newFiltersState))
        setItemWebStorage(`customMapFiltersState-${objectTypeName}`, newFiltersState)
        let newAppliedFilters = {
            ...appliedFilters,
            [fieldName]: {
                ...appliedFilters[fieldName],
                ...appliedFilter
            }
        }
        dispatch(setCustomMapAppliedFilters(newAppliedFilters))
        setItemWebStorage(`customMapAppliedFilters-${objectTypeName}`, newAppliedFilters)
    }

    return (
        <>
            {(valueType === "int" || valueType === "float") &&
                <div className="filter-input">
                    <div className={"filter-input-container" + (ignoreFilterValue?.checked ? " filter-ignore" : '')}>
                        <div className="filter-input-apply-div">
                            <span className="field-name">Год</span>
                            <InputNumber useGrouping={false} value={value} onChange={(e) => setInputFilterValue(fieldName, e.value)} />
                        </div>
                    </div>
                    <div className="map-hint-filters-checkbox-div">
                        <Checkbox
                            inputId={`ignore-${fieldName}`}
                            name={`ignore-${fieldName}`}
                            onChange={(event: any) => applyFilterInputIgnoreValue(event.checked, fieldName)}
                            checked={ignoreFilterValue?.checked}
                        />
                        <label htmlFor={`ignore-${fieldName}`} className="ms-2">{ignoreFilterValue.caption}</label>
                    </div>
                </div>
            }
        </>
    )
}
